import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PDLService } from 'src/app/services/pdl-service.service';
import { ANALYTICS } from '../core/common.constants';
import { AlertConfirmPopupService } from './alert-confirm-popup.service';
import { COMMON_CONSTANTS } from 'src/app/common/core/common.constants';

@Component({
  selector: 'app-alert-confirm-popup',
  templateUrl: './alert-confirm-popup.component.html',
  styleUrls: ['./alert-confirm-popup.component.scss'],
})
export class AlertConfirmPopupComponent implements OnInit {
  
  title: any;
  message: any;
  btnOkText: any;
  isSnagPopup: boolean = false;
  authType: any;
  modalFootershow: boolean = true;
  @Output() doneClicked = new EventEmitter();

  constructor ( private alertConfirmPopupService: AlertConfirmPopupService, public activeModal: NgbActiveModal, private pdlService: PDLService) { }
 
  ngOnInit() {  }

  onClose(closeBtnClicked?) {
    let ctaName;
    ctaName = closeBtnClicked ? COMMON_CONSTANTS.CLOSE : this.btnOkText;
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ctaName,
      assetType: ANALYTICS.BUTTON,
      modalName: this.title,
    });
    this.activeModal.close();
    this.alertConfirmPopupService.isModalOpen = false;
  }

  navigateToDashboard() {
    this.doneClicked.emit(true);
  }
  
}
